"use client";

import createIcon from './util/createIcon';
export default createIcon('M6.38,6H17.63L12,16L6.38,6M3,4L12,20L21,4H3Z', 'Details');